/**

 * Checks if the content contains all the specified trigger variables.

 */

export function isContentContainsVariables(
  content: string,
  variables: string[]
): boolean {
  return variables.some(v => new RegExp(`{{\\s*${v}\\s*}}`).test(content))
}
